// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
/** Formatting helpers — pure and unit-tested. */

/** Frequency in Hz, e.g. "440.0", "82.41". Two decimals below 100 Hz, one above. */
export function formatHz(hz: number | null): string {
  if (hz === null || !isFinite(hz) || hz <= 0) return '—';
  return hz < 100 ? hz.toFixed(2) : hz.toFixed(1);
}

/** Signed cents to a whole number, with a proper minus glyph: "+3", "−7", "0". */
export function formatCents(cents: number | null): string {
  if (cents === null || !isFinite(cents)) return '—';
  const r = Math.round(cents);
  if (r === 0) return '0';
  return `${r > 0 ? '+' : '−'}${Math.abs(r)}`;
}

/** Clock time: "0:00", "1:05". */
export function formatClock(seconds: number): string {
  const s = Math.max(0, isFinite(seconds) ? Math.floor(seconds) : 0);
  const mins = Math.floor(s / 60);
  const secs = s % 60;
  return `${mins}:${String(secs).padStart(2, '0')}`;
}

export function baseName(name: string): string {
  const noPath = name.split(/[\\/]/).pop() ?? name;
  const dot = noPath.lastIndexOf('.');
  return dot > 0 ? noPath.slice(0, dot) : noPath;
}

export function sanitizeStem(stem: string): string {
  const cleaned = stem
    .trim()
    .replace(/[^\w.\- ]+/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^[-.]+|[-.]+$/g, '');
  return cleaned || 'tunewell';
}
